
<template>
  <div
    class="absolute_center"
    style="width: 1800px;overflow-y: scroll"
    :class="{
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
    }"
  >
    <div class="selfClose_btn" style="top: 10px" @click="close"></div>
    <div class="_boxTitle">带式运输台账</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="page1">
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item label="日期：">
              <DatePicker
                :init-width="'420px'"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="beltWayDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'0'"
                @dateChange="changeTime"
              ></DatePicker>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="物料名称：">
              <el-input class="secondLevel-input" v-model="params.materialName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: -10px;margin-bottom: 0;vertical-align: middle" label=" ">
              <a class="self_btn" @click="handleCurrentChange(1)">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
              <a class="self_btn" @click="railwayExport()">导出</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 640px">
          <el-table
            :data="dataList"
            style="width: 100%"
            :header-cell-class-name="'thClass'"
            :header-row-class-name="'headTrClass'"
            :cell-class-name="'tdClass'"
            :row-class-name="'trClass'"
            class="secondLevel_table"
          >
            <el-table-column :show-overflow-tooltip="true" prop="id" label="厂家编号" width="200" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="crawlerNo" label="带式编号" width="200" align="center"></el-table-column>
            <el-table-column prop="materialName" :show-overflow-tooltip="true" label="物料名称" width="400" align="center"></el-table-column>
            <el-table-column prop="materialType" label="物料类型" width="200" align="center"></el-table-column>
            <el-table-column prop="transportWeight" label="运输重量(吨)" width="250" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="transportTime" label="运输时间" align="center"></el-table-column>
            <el-table-column prop="inOutStr" label="进出厂状态" align="center" v-if="customerId != 81"></el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="params.pageNo"
            :page-size="params.pageSize"
            layout="total,prev, pager, next, jumper"
            :total="page_total"
          ></el-pagination>
          <p>跳转</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import imgBox from './components/imgBox.vue'
import { dateFormat } from 'utils/tools'
import { DatePicker } from '@/modules/commonDatePicker'
export default {
  name: 'beltWayDetail',
  title: '详细信息',
  props: ['globalInstance'],
  components: { DatePicker },
  data() {
    return {
      pageInfo: 'beltWayDetail.vue',
      computedName: '带式运输台账组件',
      beltWayDate: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      styleType: '',
      params: {
        materialName: '',
        startTime: '',
        endTime: '',
        pageNo: 1,
        pageSize: 10,
        customerId: this.$store.state.customerId
      },
      page_total: 0,
      dataList: [],
      info: [],
      customerId: this.$store.state.customerId
    }
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: 'getDialogCompontent2'
    }),
    ...mapState({
      beltWayTime: 'beltWayTime'
    }),
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType
    }
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType
  },
  mounted() {
    if (this.beltWayTime.length > 0) {
      this.beltWayDate = this.beltWayTime
    }
    this.getBeltList()
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
      },
      deep: true
    }
  },
  methods: {
    changeTime(time) {
      this.beltWayDate = time
    },
    async getBeltList() {
      this.params.startTime = this.beltWayDate[0]
      this.params.endTime = this.beltWayDate[1]
      let url = this.globalInstance.cleanTransportIp + '/transport/crawler/list'
      let res = await this.globalInstance.$apiUtils.get3(url, this.params)
      if (res && res.list) {
        this.dataList = res.list
      }
      if (res) {
        this.page_total = res.total
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.getBeltList()
    },
    reset() {
      this.params.pageNo = 1
      this.params.materialName = ''
      this.beltWayDate = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.getBeltList()
    },
    railwayExport() {
      let that = this
      this.$message.info('正在导出数据……')
      let ip = this.globalInstance.cleanTransportIp
      let str = `${ip}/transport/crawler/export?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.beltWayDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.beltWayDate[1]
      )}&customerId=${this.customerId}&materialName=${this.params.materialName}`
      let a = document.createElement('a')
      console.log(str, 'str')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    close() {
      let that = this._.appContext.app
      this.$popup.close(that)
    }
  }
}
</script>
<style lang="scss" scoped>
.table_box .tdClass > .cell {
  font-size: 16px !important;
}
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 30px;
      color: white;
      margin-bottom: 30px;
      .item-label {
        color: #a2d8ff;
      }
    }
  }
  .picture-info {
    margin-top: 140px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .picture-inner {
      width: 50%;
      margin-bottom: 25px;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }
      .picture {
        padding: 10px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          font-weight: bold;
          color: #d7d7d7;
          font-size: 24px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: '';
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
    .label-photo {
      margin-left: 10px;
    }
  }
}
</style>
